import * as React from 'react';
import { useState, useEffect } from "react";
import axios from 'axios';
import Sidebar from '../components/sidebar'
import Footer from '../components/footer'
import Head from '../components/head'

export default function Main() {
  const [faq, setFaq] = useState([])
  const [delItem, setDelItem] = useState(null)
  const [deleting, setDeleting] = useState(false)

  useEffect(() => {
    getAllFaq();
  }, []);

  const getAllFaq = async () => {
    axios({
      method: 'post',
      url: '/api/faq/list.php',
    })
      .then(s => {
        setFaq(s.data)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };

  const deleteFaq = async () => {
    const id = delItem.id
    setDeleting(true)
    const data = new FormData();
    data.append('id', id);
    axios({
      method: 'post',
      url: '/api/faq/delete.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        if (s.data[0].msg === "pass") {
          setFaq(faq.filter((v) => v.id !== id))
        } else {
          alert("Delete nahi hua, dobara koshish karein.")
        }
      })
      .catch(s => {
        console.log('here catch =>>', s);
        alert("Delete nahi hua, dobara koshish karein.")
      })
      .finally(() => {
        setDeleting(false)
        setDelItem(null)
      });
  };

  return (
    <>
      <div className="main-wrapper">
        <Sidebar />
        <div className="page-wrapper">
          <Head />
          <div>
            <div className="page-content">
              <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-header bg-gradient-primary text-white py-4">
                      <div className="d-flex align-items-center">
                        <div>
                          <h4 className="mb-1">FAQ List</h4>
                          <span className="opacity-75">Website ke tamam FAQs manage karein</span>
                        </div>
                        <a href="addfaq" className="btn btn-light btn-sm ms-auto me-2">+ New FAQ</a>
                        <span className="badge bg-light text-dark py-2 px-3">{faq.length} Entries</span>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="table-responsive">
                        <table className="table">
                          <thead>
                            <tr>
                              <th>Sort</th>
                              <th>Question</th>
                              <th>Answer</th>
                              <th>Status</th>
                              <th>Home Page</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              faq.map((v) => (
                                <tr key={v.id}>
                                  <td>{v.sort}</td>
                                  <td className="text-truncate" style={{ maxWidth: '300px' }} title={v.q}>{v.q}</td>
                                  <td className="text-truncate" style={{ maxWidth: '350px' }} title={v.ans}>{v.ans}</td>
                                  <td>
                                    {String(v.status) === "1"
                                      ? <span className="badge bg-success">Active</span>
                                      : <span className="badge bg-secondary">Inactive</span>}
                                  </td>
                                  <td>
                                    {String(v.home) === "1"
                                      ? <span className="badge bg-info">Yes</span>
                                      : <span className="text-muted">No</span>}
                                  </td>
                                  <td>
                                    <a href={"updatefaq?id=" + v.id}>
                                      <button className="btn btn-primary btn-sm me-2">Edit</button>
                                    </a>
                                    <button className="btn btn-danger btn-sm" onClick={() => setDelItem(v)}>Delete</button>
                                  </td>
                                </tr>
                              ))
                            }
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      {/* Delete confirmation popup */}
      {delItem && (
        <div
          onClick={() => !deleting && setDelItem(null)}
          style={{
            position: 'fixed', inset: 0, zIndex: 1050,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            padding: '16px'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              background: '#fff', borderRadius: '8px', width: '100%', maxWidth: '440px',
              boxShadow: '0 10px 30px rgba(0,0,0,0.2)', overflow: 'hidden'
            }}
          >
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #e9ecef' }}>
              <h5 className="mb-0" style={{ color: '#dc3545' }}>Delete FAQ?</h5>
            </div>
            <div style={{ padding: '20px 24px' }}>
              <p className="mb-2">Kya aap yeh FAQ delete karna chahte hain?</p>
              <p className="mb-2 fw-bold" style={{ wordBreak: 'break-word' }}>"{delItem.q}"</p>
              <small className="text-muted">Delete hone ke baad yeh wapas nahi aa sakti.</small>
            </div>
            <div className="d-flex justify-content-end" style={{ padding: '16px 24px', borderTop: '1px solid #e9ecef', gap: '8px' }}>
              <button className="btn btn-light" disabled={deleting} onClick={() => setDelItem(null)}>Cancel</button>
              <button className="btn btn-danger" disabled={deleting} onClick={deleteFaq}>
                {deleting ? 'Deleting...' : 'Yes, Delete'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
